/**
 * Created by JasonChou on 17/7/19.
 */
import React from 'react'
// import {Dimensions, Text, Image} from 'react-native'
import {like2, disLike} from '../apis';
import {Avatar, Horizontal, Image, Text, Vertical} from "../../../components/index";
import {imageCut, feedShowCreateTime} from "../../../utils/uiUtils";
import {getProvinces, getCityInfo} from '../../../utils/cityUtils'
import wx from "../../../utils/wxUtils";

import ImagesGrid from './ImagesGrid'


const screenWidth = window.screen.width;

export default class UserInfoView extends React.Component {

    constructor() {
        super(...arguments);

        this.state = {
            isLike: false,
            feed: this.props.feed
        };
    }

    render() {
        return this.renderContent()
    }

    toCircleDetail = (feed) => {
        location.href = 'http://m.wenshendaka.com/feed_detail/?_id=' + feed._id
    };

    renderContent() {
        const {feed, isLike} = this.state;

        return <Vertical>
            <Vertical  onClick={() => this.toCircleDetail(feed)}  style={{backgroundColor: '#fff', padding: 15}}>
                <Horizontal>
                    <Avatar style={styles.avatar} diameter={40} source={{uri: feed.userInfo.avatar}}/>
                    <Vertical>
                        <Text style={styles.nickname}>{feed.userInfo.nickname}</Text>
                        <Text
                            style={styles.company}>{feed.userInfo.company ? feed.userInfo.company.name : (feed.userInfo.sector == 0 ? '爱好者' : '纹身师')}</Text>
                    </Vertical>
                </Horizontal>
                <Text style={styles.content}>{feed.content}</Text>
                {feed.image_urls && <div className={'imgContainer'}>
                    <ImagesGrid _id={feed._id}
                                images={feed.image_urls}/>
                </div>}
                {this.renderTopic()}

                <Horizontal style={{color: '#999', marginTop: 15, fontSize: 12}}>
                    <Horizontal style={{flex: 1}}>
                        {getCityInfo(feed.region || feed.userInfo.city)} · {feedShowCreateTime(feed.created)}
                    </Horizontal>

                    <Horizontal>
                        <Image source={require(isLike ? '../assets/ic_good_selected.png' : '../assets/ic_good.png')}
                               style={{width: 16, marginRight: 8, height: 16}}
                               onClick={() => this.goLike()}/>
                        <div style={{marginTop: 2}}>{feed.like_count}</div>
                    </Horizontal>
                    <Horizontal>
                        <Image source={require('../assets/ic_comment.png')}
                               style={{width: 16, marginRight: 8, marginLeft: 15, height: 16}}
                               onClick={() => this.setState({showEditor: true})}/>
                        <div style={{marginTop: 2}}>{feed.comment_count}</div>
                    </Horizontal>
                </Horizontal>
            </Vertical>
        </Vertical>
    }

    goLike = async () => {
        this.authWeixin();
        const {isLike} = this.state;
        const {feed} = this.state;
        let res;
        if (isLike) {
            res = await disLike(feed._id);
            let like_count = feed.like_count - 1;
            this.setState({isLike: !isLike, feed: {...feed, like_count}})
        } else {
            res = await like2(feed._id);
            let like_count = feed.like_count ? feed.like_count + 1 : 1;
            this.setState({isLike: !isLike, feed: {...feed, like_count}})
        }
    }
    renderTopic() {
        const {feed} = this.state;

        if (feed.topic) {
            return <Horizontal style={styles.topicContainer}>
                <Text style={styles.topicTitle1}>话题</Text>
                <Text style={styles.topicTitle}>{feed.topic.title}</Text>
            </Horizontal>
        }
    }


    render3Images() {
        const {image_urls} = this.state.feed;

        const list = [];

        image_urls.map(image => list.push(<img onClick={() => this.onImageClick(image)}
                                               src={imageCut(image, {width: 100, height: 100})} key={image} style={{
                width: '30%',
                height: '30%',
                marginRight: '2%',
                marginTop: '1%'
            }}/>
        ));
        return list
    }

    onImageClick(current) {
        wx.previewImage({
            current, urls: this.state.feed.image_urls
        })
    }

    render1Images() {
        const {image_urls} = this.state.feed;

        return <img src={imageCut(image_urls[0], {width: 300})} onClick={() => this.onImageClick(image_urls[0])}
                    style={{width: '100%', height: 258}}/>
    }

    renderImages() {
        const {image_urls} = this.state.feed;
        if (image_urls.length === 1) {
            return this.render1Images()
        }
        return this.render3Images()
    }
}

const styles = {
    nickname: {
        marginTop: 4,
        color: '#353535',
        fontSize: 14
    },

    content: {
        color: '#1a1a1a',
        lineHeight: 1.6,
        marginTop: 15,
        fontSize: 16,
        marginBottom: 15
    },
    company: {
        marginTop: 5,
        color: '#a1a2a5',
        fontSize: 12,
    },

    avatar: {
        marginRight: 8
    },

    topicContainer: {
        marginTop: 15,
        color: '#999'
    },

    topicTitle1: {
        fontSize: 14,
    },
    topicTitle: {
        color: '#265db4',
        marginLeft: 8,
        fontSize: 14,
    },

    bottomAD: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: 55,
        width: '100%'
    }
}



// WEBPACK FOOTER //
// ./src/apps/portfolio/screens/CircleView.js